<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

// 定义常量
const symbol = [
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAcCAYAAAFKV+zSAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPKADAAQAAAABAAAAHAAAAABKHsZYAAADRElEQVRYCeVYPY8TQQz1bIJoKNB1oEOCHAVClDQgSigOhQ7xA0CCjp6Ojp4OJPgFdJyggBJBQ4nQFVw46VZHhyhoTpAMfpvzxpnMrmezK4LESMl4xh4/2/PlWSJdvvq7hF+0gDHyvvgpoSwqrDr7JX3GPWX1ZVMIJwTt+TX6TTdpwv8b7jn6Z0xgSxm4or8We4br6J4MrK6BrV0E3K7fj8XDMWOTjXxVra0JZ8ffLpAkuFKrIIu6WTSkB/XI3+I4HS+7xvSJzrr3ZfuQWBw8RRiSpxulcI/us2sHhMlSJR5qPRDCY3qsxpSkKxZN2WxE5IvS4TTVBCxu9qLKaM9sBWl2bDVN6LMWAb0Y7VAC7R0/pIxOxljRvtP0jJwbR3mHnTbwbL3MT32VVvE4WBKhuB1rWaThsgk1NWxjee3xmPWG41qL26GWPezpSRJaZ6HGGYCC7WwVR98tEeHbHkPS+x7t0h0ZVFtj62y4d7UyzEwDhpYv/jJLn+NtFd+/nn7QEXpLp1yS1zZwE29h4IT22eMtkHUlbr0eISHO6Cgf4Q9Y8QnNLmlHL5neKg4aXHOG5/Y+Fs047qtAITPd58NC/BddlWFVdTpwlQbdL4eMHDqaF9DdAgfK65qrObkyut7mRq5zyOLl9nZa2ZFp2b4kv9vFldG3wg6kyEZJB065ABw9KvA8bRu4CWf1jr/Cp9F5S9Ec38g+IGt7jJsmkqzNAekG8q2EYq/qBCWFCC6TEV1qHB1LP5we0AcrebTUCL8bh5dZBmJBap2YX1jq2juMvKRHF0og3NoTesiX5FrZtwyBzZuxHjzapFS8AIWdUtt7ydKCJEwXpChtnYU+6IAuXUIszUuk2zscZpx1qVGiUaVYqCvEKgXTifYOp2P9E5KrybZW53qe8cGAr3n56mz4a8g5fG1/Skv2KXanPtxF3qrlgS9yCVmNiMbq/24Pt3cY739dpq9j3bM8HeoKsZbQ3H5Jy1d1DT5NPq5xqn6x9gWvxwiNJ4inj7zf3swlHeD36YX1eUHUVNXtHYbmaR69yUamf1ytsijWj484A3rdRT7djcPaSMz4QfEJbJ1n6hgHoa/ZJo3HpaOfPLs5J6nbbWc0xPsDBB8IrZ8Rxd8AAAAASUVORK5CYII=",
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAcCAYAAAFKV+zSAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPKADAAQAAAABAAAAHAAAAABKHsZYAAADXElEQVRYCeVZP2sUQRR/c57YWMh1Shq1EbEzCgZLLZTYST6Agnb2dlcI9nYK+gHEzqCFlhIhiZ1IGpPCQ7tgYRM8b/y93Z3Z2dmZfbO3S05w4dj33ry/M2/evJ0jch69Rff455BKMBvcJK355zANSpYwNDRkdYmeQbL2KEPRGzSio3Qb+BTML5heDsKuYVSXc3qjbWsXvPeNpHlbtYZgbWt6amgQ/AF4zI5bGgCFKG7AmzcuMRWuW96iOxB+BIUnK0rgds1yhaFAsCJrcPWEHdP0GTO0YfECCFnmtV6F5VuWeUAPgB/4lsNT7Qqyhhk9sYocQHHSOHgbcBJ2210moy4wYWG3jYDwLjPIZQxkE2b/i8vCcM1tn4Fx/QmzP6NTobEgbY+eqzX6ExwriKJhJ1+qSx/TWkTsp4TPLs+1SVI/bXxNLXFOr2+QWWop15ldnmpTKEPpGjLf21SjBmT6eTvLz77MknOIETObfklH6DTdTVKKraOW6YPEm2Q4M75JK9h85wCH96+mnzSl92qFkqIWDbeKlj0c0Hd1kdYZbHrC3rsSZooVHUN5fYhf9QAxvIpeA1znQsPHnBS5vI+NYi73MaPMk+/z1Yx9SNeMWOydbjimwaWbImOKjjvmwf0a9pQ3oYupXIpudjmRmwKSxuqnuS9he8tDL5m+Jz3h/SZX3pKya1PJvzaG5VKo6HFmUNOOZFgumdt0FcXhvKTIHZe6D+YVI85OmkCz5hqqwOi3KngEESOOyNXI2WFyhq60nZ2aIp/AQe/SR6l59MVieC8B6znSIOZQlJ7YX0Tli4HOAaNH5b7kgjXEp/aMxsBHljYfsI/EHyNjDqx45AvQjicA4l4SdeRNWMnGLUr3YFnfCMGyrvLxbZUjyVD3gP2Os6k1SnarYKzrkvtDwUYfAQsm/q3hxXRbi5uDyQAFh294Jovz4dAsTzjW7lXafLAbv1O7UMMvvb3bo5Supknlf7eHuwfM3//uk38du5T5YV+Xb2sOzd1TurxVL83nVwbXQVjGWRq+Nii5q1D+CbKN/fau0nQw1296JV0vVJXVsc4Bs8qsjz6LW/o2l6t1X+IUXOLQV3rbRz/dS8Cup9l/GcPsCmwJq3QcY22bhSlW9hfkJvjM3Om6oq5vDP8FmJ7VbYxkXUgAAAAASUVORK5CYII=",
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAcCAYAAAFKV+zSAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPKADAAQAAAABAAAAHAAAAABKHsZYAAADTklEQVRYCeVZP2sVQRCfjWIiWIhdQj6AiKWNYqmFYtRC8gEUYmdvl0Kwt1PQD5DKvIgWWoo2liLp84iVYiGYiGb9zd673Xl7u7dz3pEnuHDvZndmfjOzt39m9xHJYkdrxE+yOOamJctPEJpLCovGo542159A01drwtQE2Y1TRAu3iOwvMjeecXvQpvkvYNSyjtlqW2iau7Va/Q4265Zg+3HdhPdnIrNO7LgoBlFcgS8vRZuaTFjevA3tB3gWp1HgdsPytERVs6NVECcD6+AjmZvvQr2iEpbdZ7yGUFaCsLkHej+2nOlqqcgQ9lEAChQ6DIPm78o447aVn2kC3eywjNs6V8QIkgrN0YRB8klKMN10O5bguh2h92kpxUq37T0ls/o7zatay4bDeIk+fQ52EnE0GGNpTV9PBmk8bGKobnUeXjtQWe6m1l9a09WT1TQ1XFMODNbVWANccdM5ZUm0ma+i0kqWI2Z1u3EE6/idViTPxNQxK299NUPoDLOyfX4Bs+80nsz8pW9Ee28wjVRRlw13itaFt4vV9UUmUN+c894LiC6eR9j3wYg2kFrUbIFig0tuiy1ErpnHE2S33GeMsoib57zCoSxcqt753w6G8yCB4xcZsTMGrqQGNiyh2+kZrVzmap8duT2kdm5iN48VfG556Etm7Mkw9aEHF1JSLkiRC6WDYc0GYB5W9ux2wa7M2XOinC/ZM+Bi1SqvsA4lkdHG6OWI3U7TTNZioFBHvqUoyhAUSG4zOX5+0jsKBa0IB/3jfSl5VKNpBVvl7NbF4QONLeryi1grrvf/wi4vmTsrgLFr0zo6AIfePsVNXuDg0OZL+gTo2QqiPJeKIJyEycIpSt9gGY8xXLojwGNbgqUkhwg4ztkWlbY1YhFWNrvVYDmZAQJW2/onBGeUbc0s9jG+sOHz53hmLhyeYcRo1gZYpcPNZuW7NgvVRhrdHhXuVEqo/90cHiJgnP9lcadj2dCDbmBFtrpDx1tKdwS+7HC36l4VVwHmNWqXsY+ewzvaWrxcjsARxHwAkzH2p4XYVr/Sfw6z/epSBrf0XS5XOzm+i1ukV0Pk08MELH13/2UcQ/Y1t4yeOIGv1XEU8eHSfCc6wKr6c1t7VSZdaKP/AF8uyrvfJoi3AAAAAElFTkSuQmCC",
]; // 你的base64编码图片数组
const color = [
  [
    "rgba(0, 222, 255, 0)",
    "rgba(2, 245, 247, 0.77)",
    "rgba(2, 245, 247, 1)",
    "rgb(16, 62, 79)",
  ],
  [
    "rgba(255, 202, 0, 0)",
    "rgba(193, 163, 193, 1)",
    "rgba(193, 163, 193, 1)",
    "rgb(76, 85, 106)",
  ],
  [
    "rgba(0, 255, 177, 0)",
    "rgba(15, 148, 216, 0.74)",
    "rgba(15, 148, 216, 1)",
    "rgb(13, 38, 62)",
  ],
]; // 颜色数组
const xAxisData = ["2021", "2022", "2023"]; // X轴数据
const dataList = [
  {
    name: "交易总额",
    value: [39.43, 41.64, 43.7],
  },
  {
    name: "企业",
    value: [341, 374, 413],
  },
  {
    name: "人数",
    value: [962, 1078, 1210],
  },
]; // 数据列表

// 计算seriesData
const seriesData = dataList.map((item, index) => ({
  // 系列数据计算逻辑
  name: item.name || "",
  type: "line",
  areaStyle: {
    color: {
      type: "linear",
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        {
          offset: 0,
          color: color[index][1], // 0% 处的颜色
        },
        {
          offset: 1,
          color: color[index][0], // 100% 处的颜色
        },
      ],
      global: false, // 缺省为 false
    },
    // opacity: 0.5,
  },
  showSymbol: false,
  symbolSize: 14,
  symbol: "circle",
  //拐点球配置
  itemStyle: {
    normal: {
      color: color[index][2],
      shadowColor: color[index][2],
      shadowBlur: 10,
    },
  },
  lineStyle: {
    normal: {
      color: color[index][2],
      width: 1,
    },
  },

  data: item.value || [],
  // ...其他属性
}));

// 创建ECharts配置对象
const option = {
  // ... 整个ECharts配置对象
  // backgroundColor: "rgba(0, 19, 86, 0.8)", //rgba设置透明度0.1
  title: {
    show: false,
    text: "今日请求情况",
    left: "52",
    top: 16,
    textStyle: {
      fontSize: 48,
      color: " #FFFEFF",
      textShadowColor: "#00B6FF",
      textShadowBlur: 10,
      lineHeight: 67,
    },
  },
  tooltip: {
    show: true,
    trigger: "axis",
    confine: true,
    textStyle: {
      fontSize: 28, // 调整字体大小为你想要的值
    },
  },
  grid: {
    left: "78",
    right: "54",
    bottom: "46",
    top: "80",
    containLabel: true,
  },
  //图例
  legend: {
    data: [
      { name: dataList[0] && dataList[0].name, icon: `image://${symbol[0]}` },
      { name: dataList[1] && dataList[1].name, icon: `image://${symbol[1]}` },
      { name: dataList[2] && dataList[2].name, icon: `image://${symbol[2]}` },
    ],
    show: true,
    top: 36,
    right: 40,
    selectedMode: false,
    textStyle: {
      color: "#fff",
      fontSize: 28,
      lineHeight: 28,
    },
    itemStyle: {
      // borderCap: 'butt',
    },
    itemWidth: 42,
    itemHeight: 28,
    itemGap: 42,
  },
  xAxis: {
    type: "category",
    data: xAxisData,
    boundaryGap: false,
    axisTick: { show: false },
    //坐标框线
    axisLine: {
      show: true,
      lineStyle: {
        color: "##0F94D8",
        width: 4,
        type: "solid",
        opacity: 0.4,
      },
    },

    splitLine: {
      show: false,
      lineStyle: {
        color: "#3891FF",
        width: 4,
        type: "solid",
        opacity: 0.2,
      },
    },
    axisLabel: {
      lineHeight: 40,
      interval: 0,
      margin: 36,
      textStyle: {
        color: "#9EEAFF",
        fontSize: 28,
        top: 10,
        fontFamily: "Microsoft YaHei",
      },
    },
  },
  yAxis: {
    // type: 'value',
    axisTick: { show: false }, //刻度
    boundaryGap: true,
    splitLine: {
      show: false,
      lineStyle: {
        color: "#3891FF",
        width: 4,
        type: "solid",
        opacity: 0.2,
      },
    },
    axisLabel: {
      lineHeight: 40,
      interval: 0,
      margin: 30,
      show: true,
      color: "#9EEAFF",
      fontSize: 28,
      formatter: "{value}",
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#3891FF",
        width: 4,
        type: "solid",
        opacity: 0.4,
      },
    },
  },
  series: seriesData,
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
